var _tspan, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVenueNavLogoDerbyMuseumsText = function SvgVenueNavLogoDerbyMuseumsText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 364 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h419v128H0z",
    style: {
      fill: "none"
    },
    transform: "matrix(.86874 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 69.859,
    y: 67.553,
    style: {
      fontFamily: "&quot",
      fontWeight: 700,
      fontSize: 12,
      fill: "#fff"
    },
    transform: "translate(-373.043 -371.839)scale(6.25767)"
  }, "D", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "78.781px 85.639px 93.037px 100.279px",
    y: "67.553px 67.553px 67.553px 67.553px"
  }, "ERBY"))), /*#__PURE__*/React.createElement("text", {
    x: 58.621,
    y: 79.682,
    style: {
      fontFamily: "&quot",
      fontWeight: 700,
      fontSize: 12,
      fill: "#fff"
    },
    transform: "translate(-373.043 -371.839)scale(6.25767)"
  }, "M", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "69.547px 78.337px 85.135px 91.993px 100.783px 111.709px",
    y: "79.682px 79.682px 79.682px 79.682px 79.682px 79.682px"
  }, "USEUMS"))));
};
export { SvgVenueNavLogoDerbyMuseumsText as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDM2NCAxMjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgeG1sbnM6c2VyaWY9Imh0dHA6Ly93d3cuc2VyaWYuY29tLyIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoyOyI+CiAgICA8ZyBpZD0iQXJ0Ym9hcmQyIiB0cmFuc2Zvcm09Im1hdHJpeCgwLjg2ODczNSwwLDAsMSwyLjMxNDc4ZS0xNCwwKSI+CiAgICAgICAgPHJlY3QgeD0iLTAiIHk9IjAiIHdpZHRoPSI0MTkiIGhlaWdodD0iMTI4IiBzdHlsZT0iZmlsbDpub25lOyIvPgogICAgICAgIDxnIHRyYW5zZm9ybT0ibWF0cml4KDcuMjAzMiwwLDAsNi4yNTc2NywtNDI5LjQwOSwtMzcxLjgzOSkiPgogICAgICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQxIj4KICAgICAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgICAgIDx0ZXh0IHg9IjY5Ljg1OXB4IiB5PSI2Ny41NTNweCIgc3R5bGU9ImZvbnQtZmFtaWx5OidTY2FsYVNhbnNQcm8tQm9sZCcsICdTY2FsYSBTYW5zIFBybycsIHNhbnMtc2VyaWY7Zm9udC13ZWlnaHQ6NzAwO2ZvbnQtc2l6ZToxMnB4O2ZpbGw6d2hpdGU7Ij5EPHRzcGFuIHg9Ijc4Ljc4MXB4IDg1LjYzOXB4IDkzLjAzN3B4IDEwMC4yNzlweCAiIHk9IjY3LjU1M3B4IDY3LjU1M3B4IDY3LjU1M3B4IDY3LjU1M3B4ICI+RVJCWTwvdHNwYW4+PC90ZXh0PgogICAgICAgICAgICAgICAgICAgIDx0ZXh0IHg9IjU4LjYyMXB4IiB5PSI3OS42ODJweCIgc3R5bGU9ImZvbnQtZmFtaWx5OidTY2FsYVNhbnNQcm8tQm9sZCcsICdTY2FsYSBTYW5zIFBybycsIHNhbnMtc2VyaWY7Zm9udC13ZWlnaHQ6NzAwO2ZvbnQtc2l6ZToxMnB4O2ZpbGw6d2hpdGU7Ij5NPHRzcGFuIHg9IjY5LjU0N3B4IDc4LjMzN3B4IDg1LjEzNXB4IDkxLjk5M3B4IDEwMC43ODNweCAxMTEuNzA5cHggIiB5PSI3OS42ODJweCA3OS42ODJweCA3OS42ODJweCA3OS42ODJweCA3OS42ODJweCA3OS42ODJweCAiPlVTRVVNUzwvdHNwYW4+PC90ZXh0PgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";